import * as library from "nodejs-base64-encode";

export const decodeData = (hash, method = "base64") => {
  return library.decode(hash, method);
};

export const encodeData = (data, method = "base64") => {
  return library.encode(data, method);
};
